export const SEGMENT_OPTIONS = [
  { value: 1, label: 'Residencial' },
  { value: 2, label: 'Comercial' },
  { value: 3, label: 'Industrial' },
  { value: 4, label: 'Educacional' },
  { value: 5, label: 'Hospitalar' },
  { value: 6, label: 'Governamental' },
];

export const initialValues = {
  name: '',
  fantasyName: '',
  corporateName: '',
  documentNumber: '',
  stateRegistration: '',
  municipalRegistration: '',
  zipCode: '',
  street: '',
  streetNumber: '',
  complement: '',
  phoneNumber: '',
  site: '',
  email: '',
  district: '',
  typeId: '',
  status: 'active',
  stateId: '',
  cityId: '',
  description: '',
};

export const TENANT_STATUS = {
  ACTIVE: true,
  INACTIVE: false,
} as const;